import axios from "axios";
import HostService from "./host.service";
import AuthService from "./auth.service";


class OrderService {

    /**
     * Asignar revisor y preparador
     * @param order
     * @param reviewer
     * @param preparer
     * @returns {Promise<AxiosResponse<any>>}
     */
    static assignToOrder(order, reviewer, preparer, type, state, n2, exclude, year, camera, orderType, location, imagenes) {

        let subPath = 'asignar';

        if (n2) {
            subPath = 'n2/' + subPath;
        }

        const formData = new FormData();

        if (preparer) {
            formData.append("preparado", (preparer === '0' ? null : preparer));
        } else if (camera !== null) {
            formData.append("camara", camera);
        } else if (reviewer) {
            formData.append("revisado", (reviewer === '0' ? null : reviewer));
        }

        if (typeof exclude !== 'undefined') {
            formData.append("excluir", exclude);
        }

        if (state) {
            formData.append("estado", state);
        }

        if (location) {
            formData.append("localizacion", location);
        }


        // Añadir archivos (si los hay)
        if (imagenes && imagenes.length > 0) {
            imagenes.forEach(file => {
                formData.append('imagenes[]', file);
            });
        }

        // Definir cabeceras
        // IMPORTANTE: NO establecer Content-Type manualmente con FormData
        // Axios lo establece automáticamente con el boundary correcto
        const config = {
            headers: {
                ...AuthService.setToken().headers,
            }
        };

        return axios.post(
            HostService.getHost() + type +'/'+subPath+'?pedido='+order+'&ejercicio='+year+'&tipo='+orderType,
            formData,
            config
        )
            .then(response => response.data)
            .catch(error => {
                console.log(error.message);
                throw error;
            });
    }

    /**
     * Obtener pedido n2
     * @param order
     * @returns {Promise<AxiosResponse<any>>}
     */
    static getStateOrderN2(order, year, type) {
        return axios.get(HostService.getHost() + 'ventas/n2/estado?pedido='+order+'&ejercicio='+year+'&tipo='+type, AuthService.setToken())
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.message);
                throw error;
            });
    }

    /**
     * Obtener cliente de albaran
     * @param order
     * @returns {Promise<AxiosResponse<any>>}
     */
    static getCustomerOrder(serie, order, year) {
        return axios.get(HostService.getHost() +'cliente/'+serie+'/'+order+'?ejercicio='+year, AuthService.setToken())
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.message);
                throw error;
            });
    }

    /**
     * Obtener personas asigndas a un pedido
     * @param order
     * @returns {Promise<AxiosResponse<any>>}
     */
    static getPersonsOrder(order, type, year, orderType) {
        return axios.get(HostService.getHost() + type +'/personas?pedido='+order+'&ejercicio='+year+'&tipo='+orderType, AuthService.setToken())
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.message);
                throw error;
            });
    }

    /**s
     * Comprobar si tiene pedido en nave 2
     * @param order
     * @returns {Promise<AxiosResponse<any>>}
     */
    static checkOrderN2(order, year, type) {
        return axios.get(HostService.getHost() + 'ventas/n2/comprobar?pedido='+order+'&ejercicio='+year+'&tipo='+type, AuthService.setToken())
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.message);
                throw error;
            });
    }
}

export default OrderService;